// project imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import apiClient from 'utils/apiClient';
import config from 'config';

interface CustomizationState {
    isLoaded: boolean
    isOpen: string[]
    defaultId: string
    theme: string
    fontFamily: string
    borderRadius: number
    opened: boolean
}

export const initialState: CustomizationState = {
    isLoaded: false,
    isOpen: [], // for active default menu
    defaultId: 'default',
    theme: 'light',
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    opened: true
};

interface CustomizationProps {
    theme?: string
    fontFamily?: string
    borderRadius?: number
}

export const saveCustomization = createAsyncThunk(
    'customization/save',
    async (request: CustomizationProps) => {
        const response = await apiClient.post<CustomizationProps>('/me/customization', request);
        return response.data;
    }
)

export const getCustomization = createAsyncThunk(
    'customization/get',
    async () => {
        const response = await apiClient.get<CustomizationProps>('/me/customization');
        return response.data;
    }
)

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const settingCustomization = (state, customization: CustomizationProps) => {
    if (customization.theme) state.theme = customization.theme;
    if (customization.fontFamily) state.fontFamily = customization.fontFamily;
    if (customization.borderRadius) state.borderRadius = customization.borderRadius;

    state.isLoaded = true;
}

const customizationSlice = createSlice({
    name: "customization",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(saveCustomization.fulfilled, (state, action) => {
                const customization: CustomizationProps = action.payload;
                settingCustomization(state, customization);
            })
            .addCase(getCustomization.fulfilled, (state, action) => {
                const customization: CustomizationProps = action.payload;
                settingCustomization(state, customization);
            })
    },
    reducers: {
        openMenu: (state, action: PayloadAction<string>) => {
            state.isOpen = [action.payload]
        },
        setMenu: (state, action: PayloadAction<boolean>) => {
            state.opened = action.payload
        },
        setBorderRadius: (state, action: PayloadAction<number>) => {
            state.borderRadius = action.payload
        }
    }
})

export const {
    openMenu,
    setMenu,
    setBorderRadius,
} = customizationSlice.actions;
export default customizationSlice.reducer;
